import Form, {
  ButtonItem,
  ButtonOptions,
  GroupItem,
  Label,
  SimpleItem,
} from 'devextreme-react/form';
import { RequiredRule } from 'devextreme-react/validator';
import React, { useRef } from 'react';
import { useHistory } from 'react-router';
import { useLoading } from '../../contexts/loadingContext';
import { useTranslation } from '../../contexts/translation';
import useUnsavedChangesWarning from '../../hooks/useUnsavedChangesWarning';
import { IForm } from '../../types/iForm';
import { formTranslationByEdit } from '../../utils/formTranslationByEdit';

export interface ICapacityCategoriesPersonsForm extends IForm {
  dataPerson?: any;
  dataCapacityCategories?: any;
}

export const CapacityCategoriesPersonsForm = ({
  onSubmit,
  formData,
  dataPerson,
  dataCapacityCategories,
  isEdit,
}: ICapacityCategoriesPersonsForm) => {
  const { translate } = useTranslation();
  const transFormName = formTranslationByEdit('CapacityCategoryPerson', isEdit);
  const history = useHistory();
  const backRoute = '/capacity-categories-persons';
  const formRef = useRef<Form>(null);
  const { loading } = useLoading();
  const [prompt, setDirty, setClean, handleCloseButton] = useUnsavedChangesWarning(
    backRoute,
    () => {
      if (!formRef) return;
      if (formRef.current!.instance.validate().isValid) {
        setClean();
        onSubmit(null).then((result) => {
          if (result) history.push(backRoute);
          else setDirty();
        });
      }
    },
  );

  return (
    <form
      onSubmit={(e) => {
        onSubmit(e);
        if (formRef && formRef.current && !isEdit) formRef.current?.instance.resetValues();
        // @ts-ignore
        setClean();
      }}
    >
      <Form
        colCount={1}
        formData={formData}
        showValidationSummary={true}
        onFieldDataChanged={() => {
          // @ts-ignore
          setDirty();
        }}
        ref={formRef}
      >
        <GroupItem>
          <SimpleItem
            dataField="capacityCategoryId"
            editorType="dxSelectBox"
            editorOptions={{
              items: dataCapacityCategories,
              valueExpr: 'id',
              displayExpr: 'name',
            }}
          >
            <Label text={translate!('Capacity category', transFormName)} />
            <RequiredRule message={translate!('Select capacity category', transFormName)} />
          </SimpleItem>
        </GroupItem>

        <GroupItem>
          <SimpleItem
            dataField="personId"
            editorType="dxSelectBox"
            editorOptions={{
              items: dataPerson,
              valueExpr: 'personalNumber',
              displayExpr: 'fullName',
            }}
          >
            <Label text={translate!('Person', transFormName)} />
            <RequiredRule message={translate!('Select person', transFormName)} />
          </SimpleItem>
        </GroupItem>

        <GroupItem>
          <SimpleItem dataField="visible" editorType="dxCheckBox">
            <Label text={translate!('Visible', transFormName)} />
          </SimpleItem>
        </GroupItem>

        <GroupItem colCount={14}>
          <ButtonItem colSpan={1} verticalAlignment={'center'} horizontalAlignment={'left'}>
            <ButtonOptions
              width={'100%'}
              text={translate!('Close', 'Asset.Update')}
              type={'normal'}
              useSubmitBehavior={false}
              onClick={handleCloseButton}
            />
          </ButtonItem>
          <ButtonItem colSpan={1} verticalAlignment={'center'} horizontalAlignment={'left'}>
            <ButtonOptions
              width={'100%'}
              text={translate!('Save', transFormName)}
              type={'success'}
              disabled={loading}
              useSubmitBehavior
            />
          </ButtonItem>
        </GroupItem>
        {prompt}
      </Form>
    </form>
  );
};
